import { booleanAttribute, ChangeDetectionStrategy, Component, Input, numberAttribute, OnInit } from '@angular/core';

@Component({
  selector: 'kz-text-placeholder',
  templateUrl: './text-placeholder.component.html',
  styleUrls: ['./text-placeholder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextPlaceholderComponent implements OnInit {

  @Input({transform: numberAttribute}) nbLines = 1;
  @Input({transform: booleanAttribute}) biggerFirstLine = false;

  constructor() { }

  ngOnInit(): void {
  }

}
